import { PostTextEditorComponent } from './post-text-editor.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxHtmlEditorModule, DxScrollViewModule } from 'devextreme-angular';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
	declarations: [PostTextEditorComponent],
	exports: [PostTextEditorComponent],
  imports: [
		CommonModule,
		ReactiveFormsModule,
		DxHtmlEditorModule,
		DxScrollViewModule,
  ]
})
export class PostTextEditorModule { }
